import {
  Box,
  Grid,
  Link,
  Switch,
  Select,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserCountries,
  GetGroupOrScenarioDetails,
  UpdateGroupOrScenarioActivation,
  ListUpdateGroupOrScenario,
  setState,
} from "./centralAdminSlice";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import SharedComponent from "./SharedComponent";
import moment from "moment";
import CustomLoadingScreen from "../../components/ui/CustomLoadingScreen";
import CustomButton from "../../components/ui/CustomButton";
import MessageSnackbar from "../../components/ui/MessageSnackbar";

const GroupScenatioActivity = () => {
  const apiRef = useGridApiRef();
  const dispatch = useDispatch();
  const [alert, setAlert] = useState({});
  const centralAdmin = useSelector((state) => state.centralAdmin);
  const {
    isLoading,
    countries,
    selectedCountry,
    selectedCountryID,
    getGroupScenarioData,
    listUpdateGS,
    isSuccess,
    isSuccess_Info,
    isFailed,
    isFailed_Info,
  } = centralAdmin;

  const [searchText, setSearchText] = useState("");
  const [viewBy, setViewBy] = useState("");
  const [updatedIds, setUpdatedIds] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [filterData, setFilterData] = useState(getGroupScenarioData);
  const [showGroupScenarioData,setShowGroupScenarioData]= useState(false);

  const columns = [
    { field: "groupOrScenarioName", headerName: "Name", flex: 1 },
    {
      field: "validityStartDate",
      headerName: "Validity Start Date",
      flex: 1,
      valueFormatter: (params) =>moment(params.value).format('DD/MM/YYYY')
    },
    {
      field: "validityEndDate",
      headerName: "Validity End Date",
      flex: 1,
      valueFormatter: (params) => moment(params.value).format('DD/MM/YYYY')
    },
    {
      field: "activation",
      headerName: "Activity",
      flex: 1,
      renderCell: (params) => {
        return <Deactivate {...params} />;
      },
    },

    {
      field: "inactive",
      headerName: "Show / Hide",
      flex: 1,
      renderCell: (params) => {
        return <Inactive {...params} />;
      },
    },
    {
      field: "scenarioCriticality",
      headerName: "Criticality",
      flex: 1,
      renderCell: (params) => {
        return <Criticality {...params} />;
      },
    },
    // {
    //   field: "stickToQuota",
    //   headerName: "Automate STQ Decision",
    //   flex: 1,
    //   renderCell: (params) => {
    //     return <StickToQuota {...params} />;
    //   },
    // },
    // {
    //   field: "copySubmitQuota",
    //   headerName: "	Copy & Submit Quota",
    //   flex: 1,
    //   renderCell: (params) => {
    //     return <CopySubmitQuota {...params} />;
    //   },
    // },
  ];

  useEffect(() => {
    dispatch(setState("selectedCountry", ""));
    setViewBy("");
    setShowGroupScenarioData(false);
    dispatch(setState("getGroupScenarioData",[]));
    dispatch(setState("isSuccess",false));
    dispatch(setState("isFailed",false));
  }, []);

  const Deactivate = (params) => {
    const handleDeactivate = () => {
      const obj = {
        GroupOrScenarioID: params.row.groupOrScenarioID,
        GroupOrScenarioType: viewBy,
        Inactive: 1,
        Activity: "Deactivation",
        criticalityID: params.row.scenarioCriticality,
        PeriodType: params.row.periodType,
        sticktoQuota: params.row.stickToQuota,
      };

      let newObj = {
        countryID: selectedCountryID,
        viewBy: viewBy,
      };

      dispatch(UpdateGroupOrScenarioActivation(obj)).then(() => {
        apiRef.current.updateRows([{
          groupOrScenarioID:params.row.groupOrScenarioID,
          inactive:1,
          activation:"NA",
        },
      ]);
        dispatch(GetGroupOrScenarioDetails(newObj));
      });
    };
    if(params.row.activation==="NA"){
      return null;
    }
    return (
      <Box
      sx={{
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        height:'100%'
      }}>
       
      <Link onClick={handleDeactivate}
      sx={{
        cursor: "pointer",
        color: "#001489", 
        fontWeight:"bold",
        backgroundColor: "#ECEFFF",
        padding: "5px 10px", 
        borderRadius: "4px", 
        textDecoration: "none", 
        "&:hover": {
          backgroundColor: "#001489",
          color:"#FFFFFF",
          fontWeight:"bold",
        },
      }}>
        {params.row.activation !== "NA" ? params.row.activation : ""}
      </Link>
      </Box>
    );
  };

  const Inactive = (params) => {
    let inactiveValue = false;
    let isDisabledValue = false;

    params.row.inactive === 1
      ? (inactiveValue = true)
      : (inactiveValue = false);

    params.row.activation === "NA"
      ? (isDisabledValue = false)
      : (isDisabledValue = true);

    const [checked, setChecked] = React.useState(inactiveValue);

    useEffect(()=>{
      setChecked(params.row.inactive===1);
    },[params.row.inactive]);

    const [isDisabled, setIsDisabled] = React.useState(isDisabledValue);

    //update the isDisabled state when activation of a row changes
    useEffect(()=>{
      setIsDisabled(params.row.activation!=="NA");
    },[params.row.activation]);

    const handleInactive = (e) => {
      setChecked(e.target.checked);
      apiRef.current.updateRows([
        {
          groupOrScenarioID: params.id,
          inactive: e.target.checked === true ? 1 : 0,
        },
      ]);
      if (!updatedIds.includes(params.id)) {
        // If not, add it to the state array
        //setUpdatedIds([...updatedIds, params.id]);
        setUpdatedIds((prevStateArray) => [...prevStateArray, params.id]);
      }
    };
    const switchClass = `custom-switch ${checked ? 'blue-thumb blue-track' : ''}`;
    return (
      <Switch
        checked={checked}
        disabled={isDisabled}
        onChange={handleInactive}
        inputProps={{ "aria-label": "controlled" }}
        className={switchClass} /* Apply conditional classes */
      />
    );
  };

  const Criticality = (params) => {
    const [trustLevel, setTrustLevel] = useState(
      params.row.scenarioCriticality
    );

    const handleStatusChange = (e) => {
      setTrustLevel(e.target.value);
      apiRef.current.updateRows([
        { groupOrScenarioID: params.id, scenarioCriticality: e.target.value },
      ]);

      if (!updatedIds.includes(params.id)) {
        // If not, add it to the state array
        //setUpdatedIds([...updatedIds, params.id]);
        setUpdatedIds((prevStateArray) => [...prevStateArray, params.id]);
      }
    };
    return (
      <Select
        value={trustLevel}
        onChange={handleStatusChange}
        variant="outlined"
        size="small"
        fullWidth
      >
        <MenuItem value={1}>Low</MenuItem>
        <MenuItem value={2}>Medium</MenuItem>
        <MenuItem value={3}>High</MenuItem>
        {/* <MenuItem value={4}>Severe</MenuItem>
        <MenuItem value={5}>Other</MenuItem> */}
      </Select>
    );
  };


  useEffect(() => {
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, [countries]);

  useEffect(() => {
    setFilterData(getGroupScenarioData);
  }, [getGroupScenarioData]);

  const handleSearchText = (e) => {
    let value = e.target.value;
	  
		// Remove special characters
		value = value.replace(/[^a-zA-Z0-9 ]/g, "");
	  
		//Replace multiple consecutive spaces with a single space
		value = value.replace(/\s{2,}/g, " ");
	  
		// Trim leading space
		value = value.trimStart();
    setSearchText(value);
  };

  useEffect(() => {
    let filteredRows = getGroupScenarioData;

    if (searchText !== "") {
      const searchLowercase = searchText.toLowerCase();
      filteredRows = filteredRows.filter((row) => {
        return row.groupOrScenarioName.toLowerCase().includes(searchLowercase);
      });
    }

    setFilterData(filteredRows);
  }, [searchText]);

  const handleDisplay = () => {
    setUpdatedIds([]);
    dispatch(setState("getGroupScenarioData",[]));
    setSearchText("");
    if (selectedCountry === null || selectedCountry === "") {
      displayWarningAlert("Please select the Country");
      return;
    }
    if (viewBy === null || viewBy === "") {
      displayWarningAlert("Please select the View By Option");
      return;
    }
    if (viewBy === 2) {
      setVisibleColumns((prev) =>
        columns.filter(
          (col) =>
            col.field !== "scenarioCriticality" &&
            col.field !== "stickToQuota" &&
            col.field !== "copySubmitQuota"
        )
      );
    } else {
      setVisibleColumns(columns);
    }
    let obj = {
      countryID: selectedCountryID,
      viewBy: viewBy,
    };

    setShowGroupScenarioData(true);
    dispatch(GetGroupOrScenarioDetails(obj));
  };

  const handleCountryChange = (e) => {
    setShowGroupScenarioData(false);
    const name = e.target.value;
    const countryID = countries.find(
      (country) => country.countryName === name
    ).countryID;

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  const handleSave = () => {
    const uniqueUpdatedIds = Array.from(new Set(updatedIds));

    const finalArray = uniqueUpdatedIds.map((id) => {
      let updatedActivityValues = apiRef.current.getRowWithUpdatedValues(id);
      return {
        activation: "HideOrShow",
        copySubmitQuota: updatedActivityValues.copySubmitQuota,
        stickToQuota: updatedActivityValues.stickToQuota,
        groupOrScenarioID: updatedActivityValues.groupOrScenarioID,
        groupOrScenarioType: viewBy,
        inactive: updatedActivityValues.inactive,
        scenarioCriticality: updatedActivityValues.scenarioCriticality,
      };
    });

    let obj = {
      countryID: selectedCountryID,
      viewBy: viewBy,
    };

    dispatch(ListUpdateGroupOrScenario(finalArray)).then(() => {
      setUpdatedIds([]);
      console.log(listUpdateGS);
      dispatch(GetGroupOrScenarioDetails(obj));
    });
  };

  const displayWarningAlert = (msg) => {
    setAlert({
      alertSeverity: "info",
      alertDisplay: true,
      alertMessage: msg,
    });

    setTimeout(() => {
      clearAlert();
    }, [5000]);
  };

  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };
  const handleViewByChange=(e)=>{
    setShowGroupScenarioData(false);
    setViewBy(e.target.value);
  }

  const handleCloseSnackbar=()=>{
    clearAlert();
  }

  return (
    <>
      <Box mt={4}>
        <Grid
          container
          columns={12}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          pb={1}
        >
          <Grid item xs={6} sm={3} md={3} lg={3}>
            <TextField
              variant="outlined"
              label="Country"
              select={countries.length > 0 ? true : false}
              value={countries.length > 0 ? selectedCountry.countryName : ""}
              onChange={handleCountryChange}
              fullWidth
              size="small"
            >
              {countries.length > 0
                ? countries.map((country, index) => {
                    return (
                      <MenuItem
                        key={country.countryID}
                        value={country.countryName}
                      >
                        {country.countryName}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
          </Grid>

          <Grid item xs={6} sm={3} md={3} lg={3}>
            <TextField
              variant="outlined"
              label="View By"
              select={true}
              value={viewBy}
              onChange={handleViewByChange}
              fullWidth
              size="small"
            >
              {/* <MenuItem key={1} value={1}>
                {"Product Group"}
              </MenuItem> */}
              <MenuItem key={2} value={2}>
                {"Customer Group"}
              </MenuItem>
              <MenuItem key={3} value={3}>
                {"Scenario"}
              </MenuItem>
            </TextField>
          </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={6}
          container
          justifyContent={
            getGroupScenarioData.length > 0 ? "space-between" : "flex-start"
          }
          alignItems="center"
        >
          {getGroupScenarioData.length > 0 && (
            <Grid item xs={8}>
              <TextField
                variant="outlined"
                label="Search"
                value={searchText}
                onChange={handleSearchText}
                fullWidth
                size="small"
              />
            </Grid>
          )}

          <Grid
            item
            xs={getGroupScenarioData.length > 0 ? 3 : "auto"}
            container
            justifyContent={getGroupScenarioData.length > 0 ? "flex-end" : "flex-start"}
          >
             <CustomButton  onClick={handleDisplay} size="large">
             Search
            </CustomButton>
          </Grid>
        </Grid>
        </Grid>
      </Box>
      <CustomLoadingScreen isLoading={isLoading} />
      <SharedComponent />
      {(getGroupScenarioData && showGroupScenarioData) && (
        <Box mt={2} sx={{ width: "100%" }}>
          <DataGrid
            disableColumnMenu
            style={{ maxHeight: "calc(100vh - 130px)" }}            
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: "normal",
              },
              "& .MuiDataGrid-columnHeader": {
                position: "sticky",
              },
              "& .MuiDataGrid-columnHeaders": {
                maxHeight: "168px !important",
              },
              '& .MuiDataGrid-cell': {
                whiteSpace: 'normal !important',
                wordWrap: 'break-word !important',
              }
            }}
            apiRef={apiRef}
            rows={filterData || []}
            columns={visibleColumns}
            getRowId={(row) => row?.groupOrScenarioID}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20, 50, 100]}
            disableRowSelectionOnClick
          />
        </Box>
      )}
      {(getGroupScenarioData && showGroupScenarioData) && (
        <Grid item xs={12} sm={12} md={12} lg={12} mt={2}>
        <Box justifyContent="right" display="flex">

          <CustomButton  onClick={handleSave} size="large">
            Save
          </CustomButton>

        </Box>
      </Grid>
      )}
      
      {alert.alertDisplay && (
        <MessageSnackbar
          message={alert.alertMessage}
          severity={alert.alertSeverity}
          open={alert.alertDisplay}
          onClose={handleCloseSnackbar}
        />
      )}
    </>
  );
}

export default GroupScenatioActivity;
